import PropTypes from "prop-types";

/// props validation | SQ(javascript:S6774)
ActionForm.propTypes = {
  isActionButtonHidden: PropTypes.bool,
  buttonClassName: PropTypes.string,
  label: PropTypes.string,
  setModal: PropTypes.func,
  forms: PropTypes.array,
  onAction: PropTypes.func,
};
///
export function ActionForm(props) {
  const { isActionButtonHidden } = props;

  if (isActionButtonHidden) {
    return <></>;
  }

  const { buttonClassName, label } = props;
  const { setModal } = props;
  const { forms } = props;
  const { onAction } = props;

  return (
    <button
      className={buttonClassName}
      onClick={async (e) => {
        let success = true;
        if (typeof onAction === "function") {
          success = await onAction(e, forms);
        }
        success && setModal(false);
      }}
    >
      {label}
    </button>
  );
}

FormError.propTypes = {
  error: PropTypes.object,
};

export function FormError(props) {
  const { error } = props;

  return <div className={error.type}>{error.text}</div>;
}

SaveForm.propTypes = {
  onSave: PropTypes.func,
};

export function SaveForm(props) {
  const { onSave } = props;

  return (
    <ActionForm
      {...props}
      buttonClassName="modal-save-button"
      label={"Save"}
      onAction={onSave}
    />
  );
}

AcceptForm.propTypes = {
  isAcceptReady: PropTypes.bool,
  onAccept: PropTypes.func,
};

export function AcceptForm(props) {
  const { isAcceptReady } = props;
  const { onAccept } = props;

  return (
    <ActionForm
      {...props}
      buttonClassName={
        isAcceptReady ? "modal-save-button" : "modal-close-button"
      }
      label={"Accept"}
      onAction={onAccept}
    />
  );
}
